import { Swiper, Pagination, Autoplay, EffectCards } from "swiper"
Swiper.use(Pagination)
Swiper.use(Autoplay)

function verhalenSwiper() {
    const verhalenSwiper = new Swiper(".verhalen-swiper", {
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".swiper-pagination",
        },
    })

    // const arrowPrev = document.querySelector(
    //     ".verhalen-swiper-wrapper .arrow-prev"
    // )
    // const arrowNext = document.querySelector(
    //     ".verhalen-swiper-wrapper .arrow-next"
    // )

    // arrowPrev.addEventListener("click", () => {
    //     verhalenSwiper.slidePrev()
    // })

    // arrowNext.addEventListener("click", () => {
    //     verhalenSwiper.slideNext()
    // })
}

function kennisSwiper() {
    const kennisSwiper = new Swiper(".kennis-swiper", {
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".swiper-pagination",
        },
    })

    // const arrowPrev = document.querySelector(
    //     ".kennis-swiper-wrapper .arrow-prev"
    // )
    // const arrowNext = document.querySelector(
    //     ".kennis-swiper-wrapper .arrow-next"
    // )

    // arrowPrev.addEventListener("click", () => {
    //     kennisSwiper.slidePrev()
    // })

    // arrowNext.addEventListener("click", () => {
    //     kennisSwiper.slideNext()
    // })
}

function connectSwiper() {
    const connectSwiper = new Swiper(".connect-swiper", {
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".swiper-pagination",
        },
        effect: "cards",
        modules: [EffectCards],
        perSlideRotate: 0,
        rotate: false,
        perSlideOffset: 10,
        cardsEffect: {
            slideShadows: false,
            rotate: false,
            perSlideOffset: 10,
            perSlideRotate: 0,
        },
    })

    // const arrowPrev = document.querySelector(
    //     ".kennis-swiper-wrapper .arrow-prev"
    // )
    // const arrowNext = document.querySelector(
    //     ".kennis-swiper-wrapper .arrow-next"
    // )

    // arrowPrev.addEventListener("click", () => {
    //     connectSwiper.slidePrev()
    // })

    // arrowNext.addEventListener("click", () => {
    //     connectSwiper.slideNext()
    // })
}

if (document.querySelector(".connect-swiper")) {
    connectSwiper()
}

if (document.querySelector(".verhalen-swiper")) {
    verhalenSwiper()
}
if (document.querySelector(".kennis-swiper")) {
    kennisSwiper()
}
